<template>
    <ticket-confirmation
        v-if="ticketData !== undefined"
        :ticket="ticketData"
        :show-navigation-buttons="false"
    />

    <template v-else>
        <skeleton v-if="formMarkup === undefined" />
        <logged-in-contact-us-ticket-form
            v-else
            :form-markup="formMarkup"
            :facility-id-context="facilityId"
            @ticket-created="handleTicketCreated"
        />
    </template>
</template>

<script setup lang="ts">
import { inject, onMounted, ref } from 'vue'
import TicketConfirmation from '~/components/Tickets/TicketConfirmation.vue'
import Skeleton from 'primevue/skeleton'
import LoggedInContactUsTicketForm from '~/components/ContactUs/LoggedInContactUsTicketForm.vue'
import { TicketConfirmationTicketFragment } from '~/components/Tickets/TicketConfirmation.vue'

const dialogRef = inject('dialogRef')
const formMarkup = ref()
const facilityId = ref()

onMounted(() => {
    formMarkup.value = dialogRef.value.data.formMarkup
    facilityId.value = dialogRef.value.data.facilityId
})

const ticketData = ref()
function handleTicketCreated(
    createdTicketData: TicketConfirmationTicketFragment
) {
    ticketData.value = createdTicketData
}
</script>
